import type { InteractiveContent } from '@mentimeter/editor-schema/api-types-overrides';
import type { Question } from '../../legacy-series-types';
import {
  RESPONSE_POLICY_NO_RESTRICTION,
  RESPONSE_POLICY_SINGLE_RESPONSE_SINGLE_CHOICE,
  VOTE_ON_RESPONSE_ALLOW,
  VOTE_ON_RESPONSE_DENY,
} from '../../constants';
import { questionActiveToResponseMode } from '../converters/question/question-active-to-response-mode';

export const getOpenEndedInteractiveContent = (question: Question) => {
  const content: Partial<InteractiveContent> = {
    maxEntries: null,
    image: null,
    correctArea: null,
    responseRange: null,
    scoring: null,
    countdown: question.countdown_to_vote,
    interactiveContentId: `${question.id}-interactive`,
    title: question.question,
    description: question.question_description,
    voteSettings: {
      voteOnResponsePolicy: question.voting_on_answers
        ? VOTE_ON_RESPONSE_ALLOW
        : VOTE_ON_RESPONSE_DENY,
      maxEntries: question.max_votes === -1 ? null : question.max_votes,
      maxEntriesPerResponse: question.multiple_votes_on_answers ? null : 1,
    },
    choices: question.choices.map((choice) => ({
      interactiveContentChoiceId: choice.id.toString(),
      markedCorrect: choice.correct_answer,
      title: choice.label,
      responseSettings: null,
      image: null,
      correctAnswerRange: null,
      legacyChoiceId: choice.id,
      legacyQuestionMetadataFieldId: null,
    })),
    responseMode: questionActiveToResponseMode(question.active),
    responsePolicy: getResponsePolicy(question),
    responsePointQuota: null,
  };

  return content;
};

const getResponsePolicy = (question: Question) => {
  if (question.multiple_votes) {
    return RESPONSE_POLICY_NO_RESTRICTION;
  }

  return RESPONSE_POLICY_SINGLE_RESPONSE_SINGLE_CHOICE;
};
